<div class="card">
  <div class="card-header d-flex">
    <div class="row">
      <div class="col-xl-12">
        <div class="row">
          <div class="col-md-7">
            <h4>Vat Invoices</h4>
          </div>
        </div>

        <!-- Type toggle buttons -->
        <div class="d-flex gap-3 mt-2">
          <button type="button" [class]="type === 'SCHEDULER' ? 'contact selected' : 'contact'"
            (click)="getDataByType('SCHEDULER')">
            Monthly Invoice
          </button>

          <button type="button" [class]="type === 'MANUAL' ? 'contact selected' : 'contact'"
            (click)="getDataByType('MANUAL')">
            Invoice Request
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="card-body m-0">
    <!-- Top actions -->
    <div class="row mb-4">
      <div class="col-xl-6 d-flex gap-2">
        <!-- Monthly Invoice: only Filter -->
        <button *ngIf="type === 'SCHEDULER'" type="button" class="btn bg-danger-custom"
          (click)="isQuickFilter=!isQuickFilter">
          Filters <i class="feather icon-filter"></i>
        </button>
        <button type="button" *ngIf="type === 'SCHEDULER'" class="btn bg-danger-custom" (click)="exportAsExcelFile()">
          Export <i class="feather icon-download"></i>
        </button>
        <!-- Invoice Request: both Request and Filter -->
        <ng-container *ngIf="type === 'MANUAL'">
          <button type="button" class="btn bg-danger-custom" (click)="vatRequest()">
            Request <i class="feather icon-plus"></i>
          </button>
          <button type="button" class="btn bg-danger-custom" (click)="isQuickFilter=!isQuickFilter">
            Filters <i class="feather icon-filter"></i>
          </button>
          <!-- Export always visible if permission -->
          <button type="button" class="btn bg-danger-custom" (click)="exportAsExcelFile()">
            Export <i class="feather icon-download"></i>
          </button>
        </ng-container>


      </div>
    </div>

    <!-- Filter panel -->
    <div *ngIf="isQuickFilter" class="row" style="min-height: 100px">
      <div class="card w-100">
        <div class="card-body">
          <div class="row g-3">
            <div class="col-md-3">
              <label class="col-form-label" for="merchantId">Merchant ID</label>
              <input class="form-control" autocomplete="off" id="merchantId" maxlength="20" type="text"
                [(ngModel)]="merchantId" placeholder="Enter Merchant ID">
            </div>

            <div class="col-md-3">
              <label class="col-form-label" for="walletId">Wallet ID</label>
              <input class="form-control" autocomplete="off" maxlength="20" id="walletId" [(ngModel)]="walletId"
                type="text" placeholder="Enter Wallet ID">
            </div>

            <div class="col-md-3">
              <label class="col-form-label" for="invoiceNumber">Invoice Number</label>
              <input class="form-control" maxlength="22" autocomplete="off" id="invoiceNumber"
                [(ngModel)]="invoiceNumber" type="text" placeholder="Enter Invoice Number">
            </div>

            <!-- <div class="col-md-3">
              <label class="col-form-label" for="requestId">Request ID</label>
              <input class="form-control" maxlength="20" autocomplete="off" id="requestId" [(ngModel)]="requestId"
                type="text" placeholder="Enter Request ID">
            </div> -->

            <div class="col-md-4">
              <label class="col-form-label" for="fromDateTime">From Date & Time <span
                  style="color:red;">*</span></label>
              <input id="fromDate" type="datetime-local" class="form-control" [(ngModel)]="filterStartDateTime"
                [max]="currentDateTime" (change)="onStartDateTimeChange()" />
            </div>

            <div class="col-md-4">
              <label class="col-form-label" for="toDateTime">To Date & Time <span style="color:red;">*</span></label>
              <input id="toDate" type="datetime-local" class="form-control" [(ngModel)]="filterEndDateTime"
                [min]="filterStartDateTime" [max]="currentDateTime" (change)="onEndDateTimeChange()" />
            </div>

            <div class="row mt-2 justify-content-end text-right">
              <div class="mb-3 col-md-6 d-flex gap-2 justify-content-end">
                <button class="btn bg-danger-custom" type="button"
                  (click)="type === 'SCHEDULER' ? getOnHoldReport() : getVatInvoiceRequestedReport()">
                  <i class="feather icon-search"></i> Search
                </button>
                <button (click)="resetFilter()" class="btn bg-danger-custom" type="button">Reset</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mb-0" style="min-height: 380px" *ngIf="type === 'SCHEDULER'">
      <div class="col-12 col-xl-12 grid-margin stretch-card ag-theme-alpine" style="margin-bottom: 0px">
        <ag-grid-angular [enableCellTextSelection]=true (sortChanged)="onSortChange($event)"
          (filterChanged)="onFilterChange($event)" (filterModified)="onFilterModified($event)"
          (filterOpened)="onFilterOpened($event)" (gridReady)="onGridReady($event,'SCHEDULER')" (rowClicked)="onRowClicked($event)"
          (rowDoubleClicked)="onRowDoubleClicked($event)" (search)="globalSearch" [columnDefs]="schedulerColumn"
          [defaultColDef]="defaultColDef" [tooltipShowDelay]="0" [enableCellTextSelection]=true
           [rowData]="rowData" [rowModelType]="" [rowSelection]="'single'"
          style="width: 100%; height: auto;">
        </ag-grid-angular>
      </div>
    </div>

    <div class="row mb-0" style="min-height: 380px" *ngIf="type === 'MANUAL'">
      <div class="col-12 col-xl-12 grid-margin stretch-card ag-theme-alpine" style="margin-bottom: 0px">
        <ag-grid-angular [enableCellTextSelection]=true (sortChanged)="onSortChange($event)"
          (filterChanged)="onFilterChange($event)" (filterModified)="onFilterModified($event)"
          (filterOpened)="onFilterOpened($event)" (gridReady)="onGridReady($event,'MANUAL')" (rowClicked)="onRowClicked($event)"
          (rowDoubleClicked)="onRowDoubleClicked($event)" (search)="globalSearch" [columnDefs]="manualColumn"
          [defaultColDef]="defaultColDef" [tooltipShowDelay]="0" [enableCellTextSelection]=true [rowData]="rowData"
          [rowModelType]=""   [rowSelection]="'single'" style="width: 100%; height: auto;">
        </ag-grid-angular>
      </div>
    </div>

    <!-- Pagination -->
    <div class="row mt-2" *ngIf="rowData.length">
      <div class="col-4 d-flex align-items-center gap-2">
        <select [(ngModel)]="pageRecords" (ngModelChange)="onPageSizeChanges($event)" class="form-select"
          style="width:auto">
          <option *ngFor="let pageNum of pageSizeArr" [ngValue]="pageNum">{{pageNum}}</option>
        </select>
        <small class="text-muted">Total Records: {{ collectionSize }}</small>
      </div>

      <div class="col-8 d-flex justify-content-end">
        <ngb-pagination (pageChange)="onPaginationChange($event)" [(page)]="pageNumber"
          [collectionSize]="collectionSize" [pageSize]="pageRecords" [boundaryLinks]="true">
        </ngb-pagination>
      </div>
    </div>
  </div>
</div>

<!-- Rest of modals (Request, PDF Viewer, Status) remain unchanged -->

<!-- Request Invoice Modal -->
<app-modal #modalRequest [modalConfig]="modalConfigRequest" class="custom-modal"  >
  <div class="modal-title text-center">Request Invoice</div>
  <div class="form-row centered-row">
    <div class="form-group col-md-3">
      <label for="userId">Merchant ID</label>
      <input class="form-control" id="userId" maxlength="8" autocomplete="off" type="text" [(ngModel)]="userId"
        placeholder="Enter Merchant ID" (keypress)="allowOnlyNumbers($event)" />
      <div class="text-danger" *ngIf="submitted && walletMerchantError">
        Either Merchant ID or Wallet ID is required.
      </div>
    </div>
    <div class="form-group col-md-3">
      <label for="userWalletId">Wallet ID</label>
      <input class="form-control" id="userWalletId" maxlength="15" autocomplete="off" [(ngModel)]="userWalletId"
        type="text" placeholder="Enter Wallet ID" (keypress)="allowAlphaNumeric($event)"/>
      <div class="text-danger" *ngIf="submitted && walletMerchantError">
        Either Merchant ID or Wallet ID is required.
      </div>
    </div>
  </div>

  <div class="form-row centered-row">
    <div class="col-md-3">
      <label for="fromDateTime">From Date & Time <span style="color:red;">*</span></label>
      <input id="fromDate"(change)="onRequestStartDateTimeChange()" type="datetime-local" class="form-control" [(ngModel)]="startDateTime" [max]="currentDateTime" />
      <div class="text-danger"  *ngIf="submitted && !startDateTime">From Date & Time is required</div>
    </div>
    <div class="col-md-3">
      <label for="toDateTime">To Date & Time <span style="color:red;">*</span></label>
      <input id="toDate" (change)="onRequestEndDateTimeChange()" type="datetime-local" class="form-control" [(ngModel)]="endDateTime" [min]="startDateTime" [max]="currentDateTime" />
      <div class="text-danger" *ngIf="submitted && !endDateTime">To Date & Time is required</div>
    </div>
  </div>
 <div class="form-row centered-row">
  <div class="col-md-6 d-flex align-items-center custom-checkbox-wrapper">
    <input type="checkbox" id="mailCheckbox" [(ngModel)]="mailCheckboxChecked" class="custom-checkbox" />
    <label for="mailCheckbox" class="mb-0 ms-2">Note: Check this box then mail will be triggered</label>
  </div>
</div>
  <div class="form-row centered-row">
    <div class="form-group col-md-3 d-flex justify-content-center">
      <button type="button" class="btn bg-danger-custom px-4" (click)="submitRequest()">Submit</button>
    </div>
    <div class="form-group col-md-3 d-flex justify-content-center">
      <button type="button" class="btn bg-danger-custom px-4" (click)="vatRequestClose()">Cancel</button>
    </div>
  </div>
</app-modal>

<!-- PDF Viewer Modal -->
<app-modal #modalPdfViewer [modalConfig]="modalPdfViewerRequest">
  <pdf-viewer [src]="image" [show-all]="true" [zoom-scale]="'page-width'" class="viewer"></pdf-viewer>
</app-modal>

<!-- Status Modal -->
<ng-template #invoiceStatusModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">VAT Invoice Request Status</h4>
    <button type="button" class="btn-close" (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body">
    <!-- Success table -->
    <div *ngIf="successItems.length > 0" class="mb-4">
      <h5>Vat invoice generated successfully for periods:</h5>
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>Period</th>
            <th>Invoice Number</th>
            <!-- <th>Request ID</th> -->
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of successItems">
            <td>{{ item.period }}</td>
            <td>
              <span>{{ item.vatInvoiceNumber || '-' }}</span>
              <button *ngIf="item.vatInvoiceNumber" class="btn-clipboard"
                (click)="copyToClipboard(item.vatInvoiceNumber)">
                <i class="feather icon-clipboard"></i>
              </button>
            </td>
            <!-- <td>
              <span>{{ item.requestId }}</span>
              <button class="btn btn-outline-secondary btn-sm ms-2" (click)="copyToClipboard(item.requestId)">
                <i class="feather icon-clipboard"></i>
              </button>
            </td> -->
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Already present table -->
    <div *ngIf="existsItems.length > 0">
      <h5>Already present:</h5>
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>Period</th>
            <th>Invoice Number</th>
            <!-- <th>Request ID</th> -->
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of existsItems">
            <td>{{ item.period }}</td>
            <td>
              <span>{{ item.vatInvoiceNumber || '-' }}</span>
              <button *ngIf="item.vatInvoiceNumber" class="btn-clipboard"
                (click)="copyToClipboard(item.vatInvoiceNumber)">
                <i class="feather icon-clipboard"></i>
              </button>
            </td>
            <!-- <td>
              <span>{{ item.requestId }}</span>
              <button class="btn btn-outline-secondary btn-sm ms-2" (click)="copyToClipboard(item.requestId)">
                <i class="feather icon-clipboard"></i>
              </button>
            </td> -->
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</ng-template>